import { Box, Stack, TextField } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { Text } from "@src/appV2/redesign/components/Text";

import { AccountSwitcherOptionGroup } from "./AccountSwitcherOptionGroup";
import { type AgentDetails, type WorkplaceDetails } from "./types";
import { type AccountSwitcherUser } from "./useAccountSwitcherHook";

interface AccountSwitcherDropdownAdminProps {
  adminUserId: string;
  agentDetails: AgentDetails;
  workplaceDetails: WorkplaceDetails;
  handleChange: (user: AccountSwitcherUser) => void;
  searchAccounts: (searchTerm: string) => void;
  setAccountsListVisible: (visible: boolean) => void;
}

export function AccountSwitcherDropdownAdmin(props: AccountSwitcherDropdownAdminProps) {
  const {
    adminUserId,
    agentDetails,
    workplaceDetails,
    handleChange,
    searchAccounts,
    setAccountsListVisible,
  } = props;

  return (
    <>
      <Stack padding={2}>
        {/* TODO: replace text field, with redesigned component */}
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Search agents or workplaces..."
          sx={(theme) => ({
            marginBottom: 2,
            "& .MuiOutlinedInput-root": {
              backgroundColor: theme.palette.background?.inverted?.muted,
              color: theme.palette.navbar?.itemContentSelected,
              "& fieldset": {
                borderColor: theme.palette.button?.outline?.inverted?.normal?.borderColor,
              },
              "&:hover fieldset": {
                borderColor: theme.palette.button?.outline?.inverted?.hover?.borderColor,
              },
              "&.Mui-focused fieldset": {
                borderColor: theme.palette.button?.outline?.inverted?.hover?.borderColor,
              },
            },
            "& .MuiOutlinedInput-input": {
              color: theme.palette.navbar?.itemContentSelected,
              "&::placeholder": {
                color: theme.palette.navbar?.itemContent,
                opacity: 1,
              },
            },
          })}
          onChange={(event) => {
            setAccountsListVisible(true);
            searchAccounts(event.target.value);
          }}
        />
        <Button
          fullWidth
          variant="outlineInverted"
          onClick={() => {
            handleChange({ user: { userId: adminUserId }, type: "ADMIN" });
          }}
        >
          Switch To Administrator
        </Button>
      </Stack>
      <Box>
        <Box data-testid="account-switcher-agents" sx={{ marginBottom: 3 }}>
          <Text
            variant="body1"
            sx={(theme) => ({
              color: theme.palette.navbar?.sectionTitle,
            })}
          >
            AGENTS
          </Text>
          <Box>
            <AccountSwitcherOptionGroup userDetails={agentDetails} handleChange={handleChange} />
          </Box>
        </Box>
        <Box>
          <Text
            variant="body1"
            sx={(theme) => ({
              color: theme.palette.navbar?.sectionTitle,
            })}
          >
            WORKPLACES
          </Text>
          <Box>
            <AccountSwitcherOptionGroup
              userDetails={workplaceDetails}
              handleChange={handleChange}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
}
